import { createAction } from '@reduxjs/toolkit';
import { Prefix } from './prefix.types';
export const setStaticPrefixes = createAction<Prefix[]>(
  'prefix/SET_STATIC_PREFIXES',
);
